<script>
    // Import general mixin for shared functionality.
    import mixin from './../mixin';

    import SourceSet from './SourceSet.vue';

    export default {
        components: { SourceSet },
        mixins: [mixin],
        props: {
            item: {
                type: Object,
                required: true
            },
            blockView: {
                type: Boolean,
                default: true
            }
        }
    }
</script>

<template>
    <a :href="item.detailUrl" class="news-item is-flex">
        <div :class="['news-content', 'is-flex-grow-1', 'is-flex', blockView ? 'is-flex-direction-column' : '']">
            <div v-if="item.image && item.image.length" :class="['news-image', blockView ? 'mb-3' : '']">
                <source-set :image-sets="item.image" image-class="image has-curve-left-right"/>
            </div>
            <div :class="['news-content-wrapper', blockView ? '' : 'ml-5']">
                <h2 v-if="item.title" class="title is-4">
                    {{ item.title }}
                </h2>
                <div v-if="item.intro" class="block">
                    <p class="is-size-11">{{ item.intro }}</p>
                </div>
            </div>
        </div>
    </a>
</template>
